var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var ERROR_EVENT = 'error',
  PASSWORD_RESET = 'passwordReset',
  PASSWORD_SAVED = 'passwordSaved',
  ACCOUNT_ACTIVATED = 'accountActivated',
  PASSWORD_RESET_TOKEN_VALID = "passwordResetTokenValid",
  PASSWORD_RESET_TOKEN_INVALID = "passwordResetTokenInvalid",
  ACTIVATE_ACCOUNT_TOKEN_VALID = "activateAccountTokenValid",
  ACTIVATE_ACCOUNT_TOKEN_INVALID = "activateAccountTokenInvalid";


var _resetPasswordToken = null;
var _activateAccountToken = null;

var SecurityStore = assign({}, EventEmitter.prototype, {

  ERROR_EVENT: ERROR_EVENT,
  PASSWORD_RESET: PASSWORD_RESET,
  PASSWORD_SAVED: PASSWORD_SAVED,
  ACCOUNT_ACTIVATED: ACCOUNT_ACTIVATED,
  PASSWORD_RESET_TOKEN_VALID: PASSWORD_RESET_TOKEN_VALID,
  PASSWORD_RESET_TOKEN_INVALID: PASSWORD_RESET_TOKEN_INVALID,
  ACTIVATE_ACCOUNT_TOKEN_VALID: ACTIVATE_ACCOUNT_TOKEN_VALID,
  ACTIVATE_ACCOUNT_TOKEN_INVALID: ACTIVATE_ACCOUNT_TOKEN_INVALID,

  addChangeListener(type, callback) {
    this.on(type, callback);
  },

  removeChangeListener(type, callback) {
    this.removeListener(type, callback);
  },

  emitError(error) {
    this.emit(ERROR_EVENT, error);
  },

  emitPasswordReset(){
    this.emit(PASSWORD_RESET);
  },

  emitPasswordTokenValidation(isValid){
    var type = !!isValid
      ? PASSWORD_RESET_TOKEN_VALID
      : PASSWORD_RESET_TOKEN_INVALID;
    this.emit(type);
  },

  emitAccountTokenValidation(isValid){
    var type = !!isValid
      ? ACTIVATE_ACCOUNT_TOKEN_VALID
      : ACTIVATE_ACCOUNT_TOKEN_INVALID;
    this.emit(type);
  },

  emitPasswordSaved(){
    this.emit(PASSWORD_SAVED);
  },

  emitAccountActivated(){
    this.emit(ACCOUNT_ACTIVATED);
  },

  getResetPasswordToken(){
    return _resetPasswordToken;
  },

  getActivateAccountToken(){
    return _activateAccountToken;
  }

});

Dispatcher.register(function (action) {

  switch (action.actionType) {
    case ActionType.SECURITY_ERROR:
      SecurityStore.emitError(action.error);
      break;
    case ActionType.SECURITY_RESET_PASSWORD:
      SecurityStore.emitPasswordReset();
      break;
    case ActionType.SECURITY_RESET_PASSWORD_TOKEN_VALIDATE:
      _resetPasswordToken = !!action.isValid ? action.token : null;
      SecurityStore.emitPasswordTokenValidation(action.isValid);
      break;
    case ActionType.SECURITY_ACTIVATE_ACCOUNT_TOKEN_VALIDATE:
      _activateAccountToken = !!action.isValid ? action.token : null;
      SecurityStore.emitAccountTokenValidation(action.isValid);
      break;
    case ActionType.SECURITY_NEW_PASSWORD_SAVED:
      SecurityStore.emitPasswordSaved();
      break;
    case ActionType.SECURITY_ACTIVATE_ACCOUNT:
      SecurityStore.emitAccountActivated();
      break;
    default:
  }

});


module.exports = SecurityStore;
